module.exports = __webpack_public_path__ + "static/media/barbarian.7e012a97.jpg";